import { render, staticRenderFns } from "./account-manage.vue?vue&type=template&id=5e78779a&scoped=true&"
import script from "./account-manage.vue?vue&type=script&lang=js&"
export * from "./account-manage.vue?vue&type=script&lang=js&"
import style0 from "./account-manage.vue?vue&type=style&index=0&id=5e78779a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e78779a",
  null
  
)

export default component.exports